import { parsePhoneNumber } from 'libphonenumber-js'

export const maskPhoneNumber = (phone = '') => `${phone.slice(0, 2)}*****${phone.slice(7)}`

export const parsePhoneNumberFromString = (phoneNumber: string) => {
  if (!phoneNumber)
    return {
      number: '',
      country: '',
    }

  const phone = parsePhoneNumber(phoneNumber)

  return {
    number: phone.nationalNumber,
    country: phone.country,
  }
}
